import { Routes, Route, Navigate, useParams } from "react-router-dom";
import MaterialsGalleryPage from "./components/MaterialsGalleryPage";
import GalleryPageV2 from "./components/GalleryPageV2";
import PackagePage from "./components/PackagePage";
import "./App.css";

// Work-around for URL mangled by Facebook
const RedirectToEvents = () => {
  const { "*": splat } = useParams();
  return <Navigate to={`/galleries/${splat}`} replace />;
};

// Redirect old /events/:id URLs to new /galleries/:shareId
const RedirectToGalleries = () => {
  const { eventId } = useParams();
  return <Navigate to={`/galleries/${eventId}`} replace />;
};

// Redirect old /orders/:id URLs to new /packages/:shareId
const RedirectToPackages = () => {
  const { orderId } = useParams();
  return <Navigate to={`/packages/${orderId}`} replace />;
};

//  Home page placeholder - galleries/packages are accessed via share links
const HomePage = () => (
  <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
    <h1>Marta Wlazło Photography</h1>
    <p>Access your gallery or package using the link provided by the photographer.</p>
  </div>
);

function App() {
  return (
    <Routes>
      {/* Home page */}
      <Route path="/" element={<HomePage />} />

      {/* MVP routes */}
      <Route path="/galleries/:shareId" element={<GalleryPageV2 />} />
      <Route path="/galleries/:shareId/folder/:folderId" element={<GalleryPageV2 />} />
      <Route path="/packages/:shareId" element={<PackagePage />} />

      {/* Legacy routes with redirects */}
      <Route path="/events/:eventId" element={<RedirectToGalleries />} />
      <Route path="/orders/:orderId" element={<RedirectToPackages />} />
      <Route path="/.../*" element={<RedirectToEvents />} />

      {/* Keep materials route as-is for now */}
      <Route path="/materials/:galleryId" element={<MaterialsGalleryPage />} />
    </Routes>
  );
}

export default App;
